/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Status_Pending_ApprovalInputs */

const vi_stocktake_status_pending_approval = /** @type {(inputs: Stocktake_Status_Pending_ApprovalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chờ duyệt`)
};

/**

* @param {Stocktake_Status_Pending_ApprovalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_status_pending_approval = /** @type {((inputs?: Stocktake_Status_Pending_ApprovalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Status_Pending_ApprovalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_status_pending_approval(inputs)
});